__turbopack_context__.v({
  "active": "WjrcgG_active",
  "btn": "WjrcgG_btn",
  "buttons": "WjrcgG_buttons",
  "inverse": "WjrcgG_inverse",
  "label": "WjrcgG_label",
  "root": "WjrcgG_root",
});
